export const ipmStyles = {
	header: {
		backgroundColor: '#0180e9',
	},
	sidebar: {
		backgroundColor: '#262626',
		color: 'white',
	},
	button: {
		backgroundColor: '#2fc936',
		color: '#FFFFFF',
		border: '1px solid #239729',
		fontWeight: 600,
		':hover': {
			color: '#ffffff',
			backgroundColor: '#239729',
			borderColor: '#239729',
		},
	},
	text: {
		color: '#262626',
		buttonLoadingColor: '#FFFFFF',
	},
	title: {
		color: '#ffffff',
	},
	table: {
		headerBackgroundColor: '#0180e9',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'IPM Parking Platform',
	},
	logo: {
		small: {
			// Will come from an s3 bucket eventually
			src: '/ipm/ipm-map-icon-gray.png',
			height: 40,
			width: 40,
		},
		large: {
			src: '/ipm/ipm-logo-white-text.png',
			height: 49,
			width: 145,
		},
	},
	favicon: {
		src: '/ipm/ipm-map-icon-gray.png',
	},
	socials: {},
	siteUrl: 'https://www.lazparking.com/find-parking',
	orgName: 'IPM',
};
